import React, {useState, useContext} from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"
import moment from "moment"
import Imgix from "react-imgix";
import { Link as GatsbyLink } from "gatsby"

import { getLinkPropsFromMeta, getBlogPath } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'
import { getFormattedLocalizedDate } from '../../utils/time'

import { getTheme, THEME_GREY } from '../../theme/theme'
import { getImageSizes } from '../../theme/grid'
import { margin, SIZE } from '../../theme/metrics'

import PageMetaContext from '../../context/page-meta-context';
import ConfigurationContext from '../../context/configuration-context';

import SectionContainer from '../section-container'
import Truncate from "../truncate";
import ResponsiveImage from '../responsive-image'

import { Inner, ContentContainer, ImageContainer, ImageInner, Image, ContentInner, Heading, Text, Article, Category, Summary, Published, Button } from './promote-blog.styles'


const PromoteBlog = ({heading,text,items,overlap,overlapSmall}) => {
	const meta = useContext(PageMetaContext);
	const configuration = useContext(ConfigurationContext);

	const [index, setIndex] = useState(0);

	return (
		<ThemeProvider theme={(theme) => ({...theme,...THEME_GREY})}>
			<SectionContainer overlap={overlap} overlapSmall={overlapSmall}>
				<Inner>
					<ContentContainer>
						<ContentInner>
							<Heading><RichContent render={heading} /></Heading>
							<Text><RichContent render={text} /></Text>
							{items.map((item,index) => {
								if(item && item.article){
									return (
										<Article key={index} {...getLinkPropsFromMeta(item.article._meta)}>
											{item.article.category && item.article.category.name && 
												<Category>{item.article.category.name}</Category>
											}
											{item.article.headline && 
												<Summary>
													<Truncate>{item.article.headline[0].text}</Truncate>
												</Summary>
											}
											<Published>{getFormattedLocalizedDate(item.article._meta.firstPublicationDate,configuration)}</Published>
										</Article>
									)
								}
							})}
							<Button filled as={GatsbyLink} to={getBlogPath(meta.lang)}>{configuration.label_view_all}</Button>
						</ContentInner>
					</ContentContainer>
					<ImageContainer>
						<ImageInner>
							{items[0] && items[0].article && items[0].article.cover_image &&
								<ResponsiveImage image={items[0].article.cover_image} lazy aspectRatio={{width:1,height:1}} sizes={{medium:{span:6}}} sizeOptions={{defaultSize:`calc(100vw - ${margin(SIZE.small,{multiplier:2})})`}} />
							}
						</ImageInner>
					</ImageContainer>
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default PromoteBlog;